@if (accessChecked && componentVisible) {
<div class="duna-user-groups-location-container">
  <mat-card class="table-card full-width-card">
    <div class="groups-card-header">
      <mat-icon>group_work</mat-icon>
      <h3>Brugergrupperinger</h3>
    </div>
    <mat-card-content>
      <app-dynamic-table
        #groupsTable
        [dynamicInput]="dynamicInput"
      ></app-dynamic-table>
    </mat-card-content>
  </mat-card>
</div>
}
